import axios, { AxiosResponse } from 'axios';
import { GetPaymentStatusResponse } from '../../common/models/payment_status';
import { Cart } from '../../common/models/cart';

const env = process.env.REACT_APP_ENV ?? 'dev';
export const baseURL = process.env.REACT_APP_API!;

const jdMobileURLs: { [key: string] : string } = {
    dev: 'https://checkout-uat-livemesh-jdsportsuk-mobile.nonprod.jdmesh.co/?serviceAgent=1&flushCart=1',
    uat: 'https://m.jdsports.co.uk/cart/?serviceAgent=1&flushCart=1',
    prod: 'https://m.jdsports.co.uk/cart/?serviceAgent=1&flushCart=1'
}

export const jdMobileURL = jdMobileURLs[env] || jdMobileURLs.dev;

export const getCart = async (cartID:string, token: string, facia: string) => {
    console.log("getting cart from mesh...")
    const cart = await axios({
        baseURL,
        headers: { "X-Amz-Security-Token": token },
        url: `mesh/${facia}/cart/${cartID}`
    })

    return cart as AxiosResponse<Cart>;
}

export const startPayment = async (cartID: string, contactID: string, token: string, facia: string) => {

    const response = await axios({
        baseURL,
        method: "POST",
        data: {
            contactID
        },
        headers: { "X-Amz-Security-Token": token },
        url: `mesh/${facia}/cart/${cartID}/initializepayment`
    })

    return response;

}

export const getPaymentStatus = async (contactID: string, token: string) => {

    const response = await axios({
        baseURL,
        headers: { "X-Amz-Security-Token": token },
        url: `payment/${contactID}/status`
    })

    return response as AxiosResponse<GetPaymentStatusResponse>;
}

export const completePayment = async (cartID: string, contactID: string, token: string, facia: string, paymentReference?: string) => {
     const response = await axios({
         baseURL,
         method: "POST",
         data: {
            contactID,
            paymentReference
         },
         headers: { "X-Amz-Security-Token": token },
         url: `mesh/${facia}/cart/${cartID}/completepayment`
     });

     return response as AxiosResponse<any>;
}